import { lazy } from 'react';
// import { USER_ROLE } from 'constants.js';
import { DEFAULT_PATHS } from 'config.js';
import { components } from 'react-select/dist/index-ea9e225d.cjs.prod';
// import { components } from 'react-select/dist/react-select.cjs.prod';

// const ReviewerDashboard = lazy(() => import('Reviewer/ReviewerDashboard/ReviewerDashboard'));
// const ReviewerArticles = lazy(() => import('Reviewer/ReviewerArticle/ReviewerArticle'));
// // const ReviewerProfile = lazy(() => import('Reviewer/ReviewerProfile/ReviewerProfile'));
// const ReviewForm = lazy(() => import('Reviewer/ReviewerArticle/ReviewForm'));
// const Login = lazy(() => import('views/default/Login'));
// const Profile = lazy(() => import('Author/Profile/Profilepage'));

const EditorDashboard = lazy(() => import('Editor/EditorDashboard/EditorDashboard'));
const Editorhome = lazy(() => import('Editor/Editorhome/Editorhome'));
const EditorReviewers = lazy(() => import('Editor/EditorReviewers/EditorReviewers'));
const Login = lazy(() => import('views/default/Login'));
const EditorProfile = lazy(() => import('Editor/EditorProfile/EditorProfile'));
const InviteReviewers = lazy(() => import('Editor/Editorhome/InviteReviewers'));
const AddReviewers = lazy(() => import('Editor/Editorhome/AddReviewers'));
const AddClassification = lazy(() => import('Editor/Editorhome/AddClassification'));
const EditorAddReviewers = lazy(() => import('Editor/EditorReviewers/EditorAddReviewers'));
const EditorAddClassification=lazy(()=>import('Editor/EditorReviewers/EditorAddClassification'));
const RevForm=lazy(()=>import('Editor/Editorhome/RevForm'))

const authordata = JSON.parse(localStorage.getItem('authorpayload'));

const appRoot = DEFAULT_PATHS.APP.endsWith('/') ? DEFAULT_PATHS.APP.slice(1, DEFAULT_PATHS.APP.length) : DEFAULT_PATHS.APP;

const EditorRoutesAndMenuItems = {
    mainMenuItems: [
        {
            path: DEFAULT_PATHS.APP,
            exact: true,
            redirect: true,
            // to: `${appRoot}/editor_dashboard`,
            to:`${appRoot}/editor_dashboard`,
        },
        {
            path: `${appRoot}/editor_dashboard`,
            component: EditorDashboard,
            label: 'Dashboard',
            icon: 'shop',
        },

        {
            path: `${appRoot}/editor_home`,
            component: Editorhome,
            label: 'Article',
            icon: 'shop'
        },
        {
            path: `${appRoot}/editor_reviewers`,
            component: EditorReviewers,
            label: 'Reviewers',
            icon: 'shop'
        },
        {
            path: `${appRoot}/EditorProfile`,
            component: EditorProfile,
            // label: 'EditorProfile',
            // icon: 'shop'
        },
        {
            path: `${appRoot}/login`,
            component: Login,
            // label:"Login",
            // icon:"shop"
        },
        {
            path: `${appRoot}/invite_reviewers`,
            component: InviteReviewers
        },
        {
            path: `${appRoot}/add_reviewers`,
            component: AddReviewers
        },
        {
            path: `${appRoot}/add_classification`,
            component: AddClassification
        },
        {
            path: `${appRoot}/editor_addreviewers`,
            component: EditorAddReviewers
        },
        {
            path:`${appRoot}/editor_addclassification`,
            component:EditorAddClassification
        },
        {
            path:`${appRoot}/RevForm`,
            component:RevForm
        }


    ],
    sidebarItems: [],
};
export default EditorRoutesAndMenuItems;
